














import { computed, defineComponent } from '@vue/composition-api';
import debounce from '@/utils/debounce';

export default defineComponent({
	setup(_, { root }) {
		const query = computed({
			get: () => root.$store.getters['fieldsView/getQuery'],
			set: debounce((value: string) => root.$store.dispatch('fieldsView/setQuery', value), 250),
		});

		return {
			query,
		};
	},
});
